// Centralized About page content for different WCHSS years.

export const aboutContent2026 = {
  aimsScope: {
    title: 'Aims and Scope',
    paragraphs: [
      'The Third World Conference on Health and Social Science (WCHSS III) is an international interdisciplinary conference organized by Binawan University. The conference focuses on understanding the human life cycle from the perspectives of health and social sciences.',
      'Human life is a dynamic and evolving process that spans from conception to old age. Each stage of life involves biological, psychological, social, and environmental factors that influence health outcomes and quality of life.',
      'This conference aims to strengthen collaboration among researchers, academics, practitioners, and policymakers to discuss innovative approaches, evidence-based interventions, and global health challenges across the lifespan.',
      'The conference also promotes interdisciplinary integration between medicine, nursing, midwifery, public health, psychology, sociology, economics, and digital health technologies.',
    ],
    imageSrc: '',
    imageAlt: '',
  },
  scientificCommittees: {
    title: 'Scientific Committees',
    items: [
      'Prof. Henny Suzana Mediani, SKP, M.Ng, PhD',
      'Farouk Abdullah Alwyni, MA, MBA, ACSI, CDIF',
      'Dr. Aliana Dewi, SKp, MN (Binawan University, Indonesia)',
      'Dr. Mia Srimiati, S.Gz., M.Si (Binawan University, Indonesia)',
      'Dr. Maryuni, SKM, MKM (Binawan University, Indonesia)',
      'Dr. Ikhwan HS, SE, MM, M.Si',
    ],
  },
  organizingCommittee: {
    title: 'Organizing Committee',
    groups: [
      {
        label: 'Standing Committee',
        members: [
          'Prof. Henny Suzana Mediani, SKP, M.Ng, PhD',
          'Farouk Abdullah Alwyni, MA, MBA, ACSI, CDIF',
          'Dr. Aliana Dewi, SKp, MN',
          'Dr. Mia Srimiati, S.Gz., M.Si',
          'Dr. Maryuni, SKM, MKM',
          'Dr. Ikhwan HS, SE, MM, M.Si',
        ],
      },
      {
        label: 'International Advisors',
        members: [
          'Dr. Anna Suraya, MKK, SpOk (K), PhD',
          'Muhammad Arsyad Subu, RN, PhD',
          'Dr. Mrunal Shetye',
          'Janice Green',
          'Hsu, Yu Yun',
          'Tiina Simola',
        ],
      },
      {
        label: 'Chairman',
        members: ['Ns. Puji Astuti Wiratmo, SKep, MN'],
      },
      {
        label: 'Vice Chairman',
        members: ['Dr. dr. Agung Cahyono Triwibowo, M.Si'],
      },
      {
        label: 'Treasurer',
        members: [
          'Dinni Randayani Lubis, SST, M.Kes',
          'Tri Rahayu, SE',
        ],
      },
      {
        label: 'Public Relations and Sponsorship Team',
        members: [
          'Wulan Fitriani Safari, S.Pd., M.Si.',
          'apt. Ernie Halimatushadyah, M.Farm',
          'Uut Hanafi Rochman, SST, Sp.PSB',
          'Noval Said Alwynni, S.Si., M.Sc.',
        ],
      },
      {
        label: 'Secretariat and Participant Team',
        members: [
          'Septiani, S.Pt., M.PKim',
          'Hanif Aulawi, SE., MM',
          'Dian Rachma Wijayanti, M.Sc.',
          'Rita Casmita, S.Pd.',
        ],
      },
      {
        label: 'Events and Scientific Team',
        members: [
          'Ns. Agung Setiyadi, S.Kep., MM., MSN',
          'Ns. Dadan Ramdani, S.Kep., M.Kep.',
          'Bdn. Siti Nurhidayah, M.Keb',
          'Mari Esterilita, S.Tr.Sos., Sp.P.S.A',
          'Lutfi Handayani, S.ST., M.Keb',
        ],
      },
      {
        label: 'Editorial and Publication Team',
        members: [
          'Dr. Renan Prasta Jenie, STP, M',
          'Dr. Maryuni, Amd.Keb., SKM, MKM',
          'Dr. Anna Suraya, MKK, SpOK, Subsp. ToksiKO (K), PhD',
          'Putri Winda Lestari, S.KM., M.Kes.',
        ],
      },
      {
        label: 'Consumption Team',
        members: [
          'Tri Mustikowati, S.Kp., M.Kep.',
          'Yunita Sari Purba, SST.K3., MA',
        ],
      },
      {
        label: 'Facilities and Infrastructure Team',
        members: [
          'Sari Narulita, SKp, M.Si',
          'Irwanti Gustina, SST, MKes',
          'Hartanto, SE',
          'Riffi Arifiansyah',
        ],
      },
      {
        label: 'IT Team',
        members: [
          'Rasyid Avicena, S.Gz., M.Gz',
          'Rama Basyar Syahara, SE',
          'Riyadillah Reva Restiovan, Amd.',
        ],
      },
      {
        label: 'Creative Team',
        members: [
          'Nimas Sari Ardhanarisvani, SIKom',
          'Ariq Shidqi, SIKom',
          'Stevanus Saud Maruli Halomoan Sitompul, S.Ds.',
        ],
      },
      {
        label: 'Website Team',
        members: [
          'Gusti Arsyad, S.Kom., M.Cs.',
          'Andri Waskito, S.Kom., M.Kom',
          'Joyva Alians Tamam, S.Tr.T',
        ],
      },
    ],
  },
};
